module.exports = __webpack_public_path__ + "media/images/players/CASEY_PAUL-0c2e57325397bb7e69e45236e882d4f3.png";